var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { role: "main" } },
    [
      _c("ValidationObserver", {
        ref: "observer",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              var validate = ref.validate
              return [
                _vm.report
                  ? _c("form", { attrs: { id: "reportForm" } }, [
                      _c(
                        "div",
                        { staticClass: "sticky-top" },
                        [
                          _c(
                            "header-row",
                            {
                              attrs: {
                                deadline: _vm.deadline,
                                skiplink: _vm.$t("Accessibility.SkipToForm")
                              }
                            },
                            [
                              _vm._v(
                                "\n          " + _vm._s(_vm.$t("Title")) + " "
                              ),
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v(_vm._s(_vm.$t(_vm.$route.meta.title)))
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "sr-only",
                                  attrs: { "aria-live": "polite" }
                                },
                                [_vm._v(_vm._s(_vm.lockReason))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row header-links" }, [
                            _c(
                              "div",
                              { staticClass: "col-7" },
                              [
                                _c("print-pdf", {
                                  staticClass: "d-inline-block",
                                  attrs: {
                                    recordableType: "OrganisationYearlyReport"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top.center",
                                        value: {
                                          content: _vm.$t(
                                            "Btn_Instructions_Description"
                                          )
                                        },
                                        expression:
                                          "{ content: $t('Btn_Instructions_Description') }",
                                        modifiers: { top: true, center: true }
                                      }
                                    ],
                                    staticClass: "btn btn-link",
                                    attrs: {
                                      to: {
                                        name: "instructions",
                                        params: { id: "yearlyreport" }
                                      },
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("Btn_Instructions")) +
                                        "\n              "
                                    ),
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v(
                                        "-. " + _vm._s(_vm.$t("NewWindow"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fas fa-external-link-alt"
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-5 right" },
                              [
                                _c("form-status", {
                                  attrs: { saveTimeStamp: _vm.saveTimeStamp },
                                  on: { open: _vm.openLock }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("nav-row", {
                            attrs: {
                              routes: _vm.yearlyReportRoutes,
                              validationErrors: _vm.validationErrors,
                              enableNotification: _vm.hasValidationErrors,
                              condensed: true
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.sectionRenderReady
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "content-wrapper mt-3" },
                              [
                                _c("validation-errors", {
                                  attrs: { state: { invalid: invalid } }
                                }),
                                _vm._v(" "),
                                !_vm.isReadOnly
                                  ? _c(
                                      "div",
                                      { staticClass: "required-fields-info" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-asterisk icon red"
                                        }),
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t("RequiredFieldsInfo")
                                            ) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12" },
                                    [_c("router-view")],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row mt-4 mb-2" }, [
                                  _vm.saveFailed
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 save-failed warning-text"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("SaveFailed")))]
                                      )
                                    : _vm.isInLockedState
                                    ? _c("div", {
                                        staticClass:
                                          "col-12 warning-text text-lg-right",
                                        domProps: {
                                          innerHTML: _vm._s(_vm.$t("FormSent"))
                                        }
                                      })
                                    : _vm.isPastDeadline
                                    ? _c("div", {
                                        staticClass: "col-12 warning-text",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("FormPastDeadline")
                                          )
                                        }
                                      })
                                    : _vm.isLockedForAnotherUser
                                    ? _c("div", {
                                        staticClass:
                                          "col-12 warning-text text-lg-right",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("FormLockedForOtherUser")
                                          )
                                        }
                                      })
                                    : _vm.isLockedForAnotherApp
                                    ? _c("div", {
                                        staticClass:
                                          "col-12 warning-text right",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("FormLockedForOtherApp")
                                          )
                                        }
                                      })
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "row justify-content-between"
                                  },
                                  [
                                    !_vm.isReadOnly
                                      ? _c(
                                          "div",
                                          { staticClass: "col-auto mb-1" },
                                          [
                                            _vm.validating
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-secondary",
                                                    attrs: {
                                                      type: "button",
                                                      disabled: "",
                                                      "aria-disabled": "true"
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "spinner-border spinner-border-sm"
                                                    }),
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Btn_Validating"
                                                          )
                                                        ) +
                                                        "\n              "
                                                    )
                                                  ]
                                                )
                                              : _vm.saveFailed
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-inline-block"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-secondary",
                                                        attrs: {
                                                          type: "button",
                                                          disabled: "",
                                                          "aria-disabled":
                                                            "true"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Btn_Validate"
                                                              )
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.top.center",
                                                        value: {
                                                          content: _vm.$t(
                                                            "Btn_Validate_Description"
                                                          )
                                                        },
                                                        expression:
                                                          "{ content: $t('Btn_Validate_Description') }",
                                                        modifiers: {
                                                          top: true,
                                                          center: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "btn btn-secondary",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.manualValidateRecord()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.$t("Btn_Validate")
                                                        ) +
                                                        "\n                "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "sr-only"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Btn_Validate_Description"
                                                              )
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-sm-auto float-sm-right"
                                      },
                                      [
                                        _vm.isNotFirstTab()
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-secondary",
                                                attrs: {
                                                  type: "button",
                                                  "aria-label": _vm.$t(
                                                    "Btn_Back_Description"
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goToPreviousPage()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-chevron-left"
                                                }),
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(_vm.$t("Btn_Back")) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isNotLastTab()
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-secondary",
                                                attrs: {
                                                  type: "button",
                                                  "aria-label": _vm.$t(
                                                    "Btn_Next_Description"
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goToNextPage()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(_vm.$t("Btn_Next")) +
                                                    "\n                "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-chevron-right"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.sending
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-secondary",
                                                attrs: { type: "button" }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "spinner-border spinner-border-sm"
                                                }),
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t("Btn_Sending")
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "button",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName:
                                                      "v-tooltip.top.center",
                                                    value: {
                                                      content: _vm.sendTooltip
                                                    },
                                                    expression:
                                                      "{ content: sendTooltip }",
                                                    modifiers: {
                                                      top: true,
                                                      center: true
                                                    }
                                                  }
                                                ],
                                                staticClass:
                                                  "btn btn-secondary",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.sendRecord()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(_vm.$t("Btn_Send")) +
                                                    "\n                "
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "sr-only" },
                                                  [
                                                    _vm._v(
                                                      "-. " +
                                                        _vm._s(_vm.sendTooltip)
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }